import React, {useRef} from 'react';
import {useRecoilState, useRecoilValue, useSetRecoilState} from 'recoil';
import {useNavigate} from 'react-router';

import styles from './styles.module.scss';
import {user} from '../../store/user';
import {ToastMessage, isOpenToast} from '../../store';
import {BrandListItems} from '../../store/brand';
import {likeBrand} from '../../services/brands';
import useImageHeight from '../../hooks/useImageHeight';

interface Props {
  item: BrandListItemType;
}

export default function BrandListItem({item}: Props) {
  const navigator = useNavigate();
  const {height: imgHeight, imageRef} = useImageHeight();
  const accessToken = useRecoilValue(user);
  const {title, imageList: images, categoryList, info, isBookmark} = item;
  const [brandItems, setBrandItems] = useRecoilState(BrandListItems);
  const setToastMessage = useSetRecoilState(ToastMessage);
  const setOpenToastModal = useSetRecoilState(isOpenToast);
  const carouselRef = useRef<HTMLDivElement>(null);
  const updateBrandItems = (isBookmark: boolean) => {
    const _brandItems = JSON.parse(JSON.stringify(brandItems));
    _brandItems.forEach((bi: BrandListItemType) => {
      if (bi.id === item.id) {
        bi.isBookmark = isBookmark;
      }
    });
    setBrandItems(_brandItems);
  };
  const doLike = async ($event: React.MouseEvent<HTMLSpanElement>) => {
    $event.preventDefault();
    $event.stopPropagation();
    if (!accessToken) {
      navigator('/login', {
        state: {
          prevPath: `${location.pathname}${location.search}`,
        },
      });
      return;
    }
    await likeBrand(accessToken, item.parentId, !isBookmark);
    updateBrandItems(!isBookmark);
    if (!isBookmark) {
      setToastMessage('스크랩이 완료되었습니다.');
      setOpenToastModal(true);
    }
  };
  return (
    <div
      className={styles.wrapper}
      onClick={() =>
        navigator(`/brand/${item.parentId}/${item.id}`, {
          state: {
            brand: item,
            prev: location.pathname.replace('/', ''),
            scrollEnabled: true,
          },
        })
      }>
      <div className={styles.contentsTop}>
        <div className={styles.titleWrapper}>
          <h3>{title}</h3>
          <div className={styles.category}>{categoryList.join(' ・ ')}</div>
        </div>
        <div className={styles.likeWrapper}>
          <span
            className={`${styles.likeIcon} ${isBookmark ? styles.filled : ''}`}
            onClick={($event: React.MouseEvent<HTMLSpanElement>) =>
              doLike($event)
            }></span>
        </div>
      </div>
      <div className={styles.description}>{info}</div>
      <div className={styles.imgWrapper} ref={carouselRef}>
        <div>
          {images &&
            images.slice(0, 3).map((image, i) => {
              return (
                <img
                  ref={i === 0 ? imageRef : null}
                  key={`${image}_${i}`}
                  src={image}
                  style={{height: `${imgHeight}px`}}></img>
              );
            })}
        </div>
      </div>
    </div>
  );
}
